import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1cd62e98&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1cd62e98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd62e98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd62e98')) {
      api.createRecord('1cd62e98', component.options)
    } else {
      api.reload('1cd62e98', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1cd62e98&scoped=true", function () {
      api.rerender('1cd62e98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/QuotationCustomer/shippingCost/index.vue"
export default component.exports